import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import Div from '../Page/Div';
import { WPImage } from '../UI/WPImage';
import ImageContainer from '../UI/ImageContainer';
import { sanitize } from '../../utils';
import { groupParallaxElements, isMobileWidth, MOBILE_SAFE_RESIZE, } from '../globalUtils';
const sectionHeightMultiplier = 3.5;
const scrollMultiplier = 400;
const fixedRatioHeight = 1000;
const AboutHeaderSection = ({ content, idx, allowOpen, }) => {
    const { title, height_multiplier, height_multiplier_mobile, full_width_title, elements, } = content?.about_header ?? {};
    const [mobileView, setMobileView] = useState(isMobileWidth());
    const mobileViewRef = useRef(mobileView);
    mobileViewRef.current = mobileView;
    const containerRef = useRef(null);
    useEffect(() => {
        window.addEventListener('scroll', onScroll);
        window.addEventListener(MOBILE_SAFE_RESIZE, onResize);
        onScroll();
        onResize();
        return () => {
            window.removeEventListener('scroll', onScroll);
            window.removeEventListener(MOBILE_SAFE_RESIZE, onResize);
        };
    }, []);
    const onResize = () => {
        const mobile = isMobileWidth();
        if (mobile && !mobileViewRef.current) {
            setMobileView(true);
        }
        if (!mobile && mobileViewRef.current) {
            setMobileView(false);
        }
        onScroll();
    };
    const onScroll = () => {
        requestAnimationFrame(handleScroll);
    };
    const handleScroll = () => {
        if (!containerRef.current)
            return;
        containerRef.current.dispatchEvent(new CustomEvent('animation', {
            detail: {
                pos: (document.documentElement.scrollTop / window.innerHeight) *
                    -scrollMultiplier,
            },
        }));
    };
    const elementsWithGroups = mobileView
        ? groupParallaxElements(elements ?? [])
        : elements;
    const sortedElements = (elementsWithGroups ?? []).sort((a, b) => a.depth < b.depth ? -1 : 1);
    const heightMultiplier = mobileView
        ? height_multiplier_mobile || height_multiplier || 3.5
        : (height_multiplier ?? 3.5);
    const getCard = (image, title, text) => (_jsxs(_Fragment, { children: [_jsx(WPImage, { id: image }, `${image + mobileView + 'img'}`), _jsx("div", { className: "about-card-title", children: title }, `${image + mobileView + title}`), _jsx("div", { className: "about-card-text alt-font", dangerouslySetInnerHTML: {
                    __html: sanitize(text),
                } }, `${image + mobileView + 'text'}`)] }));
    return (_jsxs("div", { className: "about-container", ref: containerRef, children: [_jsx("div", { className: "about-spacer" }), _jsx(Div, { blocked: false, className: "about-title", delay: 0, children: _jsx("div", { className: `about-title-wrapper${!full_width_title ? ' about-title-wrapper-width' : ''}`, children: title }) }), _jsx("div", { className: "about-spacer-2" }), _jsx("div", { className: "about-animation", style: {
                    height: `calc(var(--pageWidth) * ${heightMultiplier})`,
                }, children: _jsx("div", { className: "about-animation-fixed-container", children: sortedElements.map((item, idx) => {
                        const { position, position_mobile, hide_on_mobiles, image, text, depth, mobile_depth, type, title, priority, group_on_mobiles, group_elements, } = item;
                        const d = parseFloat(mobileView ? mobile_depth || depth || '0' : depth || '0');
                        const pos = mobileView ? position_mobile || position : position;
                        const hidden = hide_on_mobiles && mobileView;
                        const isCard = type === 'card';
                        return (_jsx(ImageContainer, { setup: pos, allowOpen: true, delay: 4 + Math.random() * 2, depth: d, noHeight: !image, boundingScroll: true, children: _jsx(Div, { className: "about-wrapper", delay: d + 1, children: hidden ? null : group_elements ? (_jsx("div", { className: `about-group-content${isCard ? ' card' : ''}`, children: group_elements.map((element) => {
                                        return (_jsxs(_Fragment, { children: [isCard ? (getCard(element.image, element.title, element.text)) : (_jsx("div", { dangerouslySetInnerHTML: {
                                                        __html: sanitize(element.text),
                                                    } }, `${element.text + mobileView + 'elem'}`)), _jsx("div", { className: `spacer${isCard ? ' max' : ''}` }, `${element.text + mobileView + 'spacer'}`)] }));
                                    }) }, `${pos + mobileView + 'elem'}`)) : type === 'image' ? (_jsx(WPImage, { id: image, priority: !!priority }, `${image + mobileView}`)) : type === 'text' ? (_jsx("div", { dangerouslySetInnerHTML: {
                                        __html: sanitize(text),
                                    } }, `${text + mobileView}`)) : isCard ? (getCard(image, title, text)) : null }, `${pos + mobileView}`) }, `${position}${type}${mobileView}`));
                    }) }) })] }));
};
export default AboutHeaderSection;
